var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", [
    _c("a", { attrs: { href: _vm.shop.ShopId + "/carte/" + _vm.item.tid } }, [
      _vm._v(_vm._s(_vm.item.product.dn)),
    ]),
    _vm._v(" "),
    _c(
      "ul",
      _vm._l(_vm.childs3, function (item) {
        return _c(
          "li",
          { key: item.tid },
          [_c("SitemapTreeItem", { attrs: { shop: _vm.shop, item: item } })],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }